/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../ui_elements/ui_element';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "service": {
            "nested": {
              "v1": {
                "nested": {
                  "FormScreen": {
                    "fields": {
                      "content": {
                        "type": ".squareup.bbfrontend.service.v1.UiElement",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.service?.nested?.v1?.nested?.FormScreen) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FormScreen @ squareup/bbfrontend/common/workflow/screens/form_screen.proto at 11:1
 */
export const FormScreen = $root.lookupType('squareup.bbfrontend.service.v1.FormScreen');
fixType(FormScreen);
Builder.createAndAttachToType(FormScreen);